import type { SxProps, Theme } from "@mui/material/styles";
import theme from "../utils/theme";

export const dashboardPanelChildNavArrowIcon: SxProps<Theme> = {
  fontSize: 14,
  color: "#333232",
};

export const dashboardPanelChildNavButton: SxProps<Theme> = {
  width: "100%",
  justifyContent: "flex-start",
  textTransform: "none",
  textDecoration: "none",
  gap: "10px",
  py: "6px",
  px: "8px",
  minHeight: 0,
  borderRadius: "4px",
  color: "rgba(0, 0, 0, 0.8)",
  fontSize: 16,
  fontWeight: 400,
  lineHeight: 1.5,
  textAlign: "left",
  boxShadow: "none",
  transition: "background-color 150ms ease",
  "& .MuiButton-startIcon": {
    marginRight: 0,
    marginLeft: 0,
  },
  "&:hover": {
    bgcolor: "#EBEBEB",
    color: "rgba(0, 0, 0, 0.8)",
    textDecoration: "none",
  },
  "&:hover .MuiSvgIcon-root": {
    color: "#333232",
  },
};

export const breadcrumbsStyles: SxProps<Theme> = {
  fontSize: "0.875rem",
  fontWeight: 300,
  color: theme.palette.text.secondary,
  display: "inline",
}